export default __webpack_public_path__ + "static/media/dsp-payout.8747b809.png";